import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';
 
@Injectable({
  providedIn: 'root'
})
export class BookingService {
 
  constructor(private crudService: CrudService) { }
 
  Get_BookingCategory(): Observable<any> {
    debugger;
    return this.crudService.get<any>('/api/booking/Get_BookingCategory');
  }
 
}
 
 
